import { render, staticRenderFns } from "./GlobalLoad.vue?vue&type=template&id=3cbdf5aa"
import script from "./GlobalLoad.vue?vue&type=script&lang=js"
export * from "./GlobalLoad.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoad.vue?vue&type=style&index=0&id=3cbdf5aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports